import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {startSteamAuthFlow} from 'app/utils/steamLink';
import {startBattlenetAuthFlow} from 'app/utils/battlenetAuth';
import logEvent from 'app/amplitude/log_event';
import {pushAnalyticsEvent} from 'app/utils/analytics';

interface Props {
    redirectUrl?: string;
    usingOnTab?: string;
    getPromocode?: () => string | undefined;
    confirmTerms?: () => boolean;
}

type AuthFlow = (options: {promocode?: string, redirectUrl?: string, termsOfUse?: boolean}) => void;

export default class FastRegistrationSingWithPlatforms extends PureComponent<Props> {
    startRegistration = (method: string, startAuthFlow: AuthFlow): void => {
        const {redirectUrl, usingOnTab, getPromocode, confirmTerms} = this.props;
        const termsOfUse = confirmTerms?.();

        if (termsOfUse === false) {
            return;
        }

        logEvent('JOIN_PAGE_LEAD', {
            SOURCE: usingOnTab,
            method
        });
        pushAnalyticsEvent('registration_start', {
            method,
            placement: usingOnTab || 'registration_popup'
        });

        startAuthFlow({
            promocode: getPromocode?.(),
            redirectUrl,
            termsOfUse
        });
    };

    handleSteamClick = (): void => this.startRegistration('steam', startSteamAuthFlow);

    handleBattlenetClick = (): void => this.startRegistration('battlenet', startBattlenetAuthFlow);

    render(): ReactNode {
        return (
            <div className="registration-sign-with">
                <div className="registration-sign-with__title">
                    <span>{I18n.t('sign_in_with')}</span>
                </div>
                <ul className="registration-sign-with__list">
                    <li>
                        <button
                            type="button"
                            className="button-sign-with"
                            onClick={this.handleSteamClick}
                        >
                            <SpriteIcon name="#svg-steam-icon" className="svg-default" />
                        </button>
                    </li>
                    <li>
                        <button
                            type="button"
                            className="button-sign-with"
                            aria-label={I18n.t('sign_with_battlenet')}
                            onClick={this.handleBattlenetClick}
                        >
                            <SpriteIcon name="#svg-battlenet-icon" className="svg-default" />
                        </button>
                    </li>
                </ul>
            </div>
        );
    }
}
